import "maplibre-gl/dist/maplibre-gl.css";
import { Link, useParams } from "wouter";
import { ArtBoxCard } from "../components/ArtBox";
import { useGeolocation } from "../util/useGeolocation";
import { CheckinForm } from "../components/CheckinForm";

export function Collect() {
  const { position, error, request } = useGeolocation();
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <h1>
        <Link to="/nearby">&larr;</Link> Collect
      </h1>

      <header>
        {!position && <button onClick={request}>Request location</button>}
        {error && <div>Error: {error.message}</div>}
      </header>

      <main>
        <ArtBoxCard id={id} />

        <CheckinForm id={id} position={position} />
      </main>
    </>
  );
}
